import http from '../http'

export default {
  changeCurrentUserPassword(data) {
    return http.put('/security-ws-rest/users/currentuser/password', data)
  },

  getCurrentUser() {
    return http.get('/security-ws-rest/users/currentuser')
  },

  listAuthentications(req) {
    return http.get('/security-ws-rest/authentications', { params: req })
  },

  getOrganization() {
    return http.get('/security-ws-rest/organization')
  },

  createOrganization(data) {
    return http.post('/security-ws-rest/organizations', data)
  },

  updateOrganization(id, data) {
    return http.put(`/security-ws-rest/organizations/${id}`, data)
  },

  requestPasswordReset(username) {
    return http.post('/security-ws-rest/users/requestpasswordreset', { username })
  },

  passwordReset(key, password) {
    return http.post('/security-ws-rest/users/passwordreset', { key, password })
  },

  logout() {
    return http.post('/security/dologout')
  },

  userInfo() {
    return http.get('/security/context.json')
    // authenticated: {"authStatus":{"TIME_ZONE":"GMT","TIME_ZONE_OFFSET":0,"ROLES":["ROLE_CODE_DISSECTOR","ROLE_RUNAS","ROLE_METADATA_SCHEMA_MANAGER","ROLE_EPEDIGREE_EXPORTER","ROLE_ORGANIZATION_ADMIN","ROLE_CODE_STATUS_MANAGER","ROLE_KC_STATISTICS_VIEWER","ROLE_PRODUCT_READER","ROLE_EXTERNAL_CODE_VALIDATOR","ROLE_USER","ROLE_PICKING_LIST_MANAGER","ROLE_TREE_UPLOADER","ROLE_OPS","ROLE_METADATA_SCHEMA_READER","ROLE_VALIDATION_LOG_VIEWER","ROLE_TREE_EDITOR","ROLE_FIND_SIMILAR_CODES","ROLE_ROLL_VIEWER","ROLE_ORDER_MANAGER","ROLE_VIEW_ALL_ORDERS","ROLE_ATI_MANAGER","ROLE_BATCH_AUTHENTICATOR","ROLE_RECALL_MANAGER","ROLE_TRACKER","ROLE_CODE_MANAGER","ROLE_PRODUCT_METADATA_SCHEMA_READER","ROLE_CODE_STATUS_CONFIG_MANAGER","ROLE_NODE_EDITOR","ROLE_SECTION_MANAGER","ROLE_ROLL_CREATOR","ROLE_PRODUCT_MANAGER","ROLE_SUPPLYCHAIN_SUPERVISOR","ROLE_PACKAGE_TYPE_MANAGER","ROLE_BATCH_DATA_READER","ROLE_SECTION_ACTIVATOR","ROLE_PICKING_LIST_SHIPPER","ROLE_ORDER_STATISTICS_VIEWER","ROLE_METADATA_READER","ROLE_TRACER","ROLE_ATI_VIEWER","ROLE_SUPPORT","ACTUATOR","ROLE_SECURITY_ADMIN","ROLE_VANGUARD_OPERATOR","ROLE_METADATA_MANAGER","ROLE_BULK_SMS_SENDER","ROLE_LOCATION_MANAGER","ROLE_PICKER","ROLE_TRACKING_STATISTICS","ROLE_ORDER_PERMISSIONS_MANAGER","ROLE_ADMIN","ROLE_CODE_DOWNLOADER","ROLE_PRODUCT_METADATA_SCHEMA_MANAGER"],"USERNAME":"jovica","AUTH_METHOD":"username","SESSION_TIMEOUT":1800},"custom_ui":false,"host":"carnage","instanceName":"core.dev.kezzler.net","lastServerTime":"2017-05-08T13:27:34.607Z","organization":{"id":1,"name":"Default Organization"},"title":"Dev"}
    // not auth: {"authStatus":null,"host":"carnage","instanceName":"core.dev.kezzler.net","lastServerTime":"2017-05-08T13:29:19.265Z","title":"Dev"}
  },

  login(username, password, rememberMe) {
    const btoa = window.btoa(`${username}:${password}`)
    return http.get('/security/authstatus', {
      headers: {
        'X-NoAuthChallenge': '1', // ssp specific header
        'X-Init-Session': '1', // ssp specific header
        Authorization: `Basic ${btoa}`
      },
      params: {
        _spring_security_remember_me: rememberMe ? 'yes' : 'no'
      }
    })
  },

  listRoles() {
    return http.get('/security-ws-rest/roles')
  },

  removeUserFromGroup(groupId, userId, data) {
    return http({
      method: 'DELETE',
      url: `/security-ws-rest/group/${groupId}/member/${userId}`,
      data
    })
  },

  addUserToGroup(groupId, userId, data) {
    return http({
      method: 'PUT',
      url: `/security-ws-rest/groups/${groupId}/member/${userId}`,
      data
    })
  },

  createGroup(req) {
    return http.post('/security-ws-rest/groups', { group: req })
  },

  updateGroup(group) {
    return http.put(`/security-ws-rest/groups/${group.id}`, { group })
  },

  deleteGroup(id, data) {
    return http({
      method: 'DELETE',
      url: `/security-ws-rest/groups/${id}`,
      data
    })
  },

  getGroup(id) {
    return http.get(`/security-ws-rest/groups/${id}`)
  },

  listGroups(req) {
    return http.get('/group/v1/groups', { params: req })
  },

  listChildGroups(id, req) {
    return http.get(`/group/v1/groups/${id}/groups`, { params: req })
  },

  listGroupsFromOrganization(params) {
    return http({
      method: 'GET',
      url: '/group/v1/groups',
      params,
      roles: ['ROLE_RUNAS']
    })
  },

  listUsersNonPriv(req) {
    return http.post('/security-ws-rest/users/filter', req)
  },

  listUserGroups(id, req) {
    return http.get(`/user/v1/users/${id}/groups`, { params: req })
  },

  listPrivelegedUsers(params, organizationId) {
    const req = params
    if (organizationId) {
      req.organizationId = organizationId
    }
    return http.post('/security-ws-rest/privileged/users/filter', req)
  },

  listUsers(req) {
    return http.get('/user/v1/users', { params: req })
  },

  listIpBans(req) {
    return http.get('/security-ws-rest/ip-bans', { params: req })
  },

  unBanIp(ip) {
    return http.delete('/security-ws-rest/ip-bans', {
      data: {
        ip
      }
    })
  },

  banIp(req) {
    return http.put('/security-ws-rest/ip-bans', req)
  },

  savePermissions(id, type, perms) {
    return http.put(`/security-ws-rest/acl/${id}/${type}`, perms)
  },

  getPermissions(id, type) {
    return http.get(`/security-ws-rest/acl/${id}/${type}`)
  },

  runAs(username) {
    const headers = { 'X-NoAuthChallenge': '1', 'X-Runas': username }
    return http.post('/security/authstatus', null, { headers })
  },

  listOrganizations(req) {
    return http.get('/security-ws-rest/organizations', { params: req })
  },

  listAllUsers(req) {
    return http.get('/user/v1/users', { params: req })
  },

  getUser(id) {
    return http.get(`/security-ws-rest/users/${id}`)
  },

  getUserPreferences(id) {
    return http.get(`/security-ws-rest/users/${id}/preferences`)
  },

  updateUserPreferences(id, data) {
    return http.put(`/security-ws-rest/users/${id}/preferences`, data)
  },

  createUser(data) {
    return http.post('/security-ws-rest/users', data);
  },

  updateUser(id, data) {
    return http.put(`/security-ws-rest/users/${id}`, data)
  },

  unlockUser(id) {
    return http({
      method: 'DELETE',
      url: `/user/v1/users/${id}/locked`,
      roles: ['ROLE_ORGANIZATION_ADMIN']
    })
  },

  deleteUser(id) {
    return http({
      method: 'DELETE',
      url: `/security-ws-rest/users/${id}`,
      data: { userId: id }
    })
  },

  undeleteUser(id) {
    return http({
      method: 'DELETE',
      url: `/user/v1/users/${id}/deleted`,
      data: { id }
    })
  },

  getConfiguration() {
    return http.get('/configuration-ws-rest/organizations/configuration')
  },

  updateConfiguration(cfg) {
    return http.put('/configuration-ws-rest/organizations/configuration', cfg)
  },

}



// WEBPACK FOOTER //
// ./src/service/apis/Security.js